import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import $ from "jquery";
import Accents from "remove-accents";
import Alert from "react-s-alert";
import SessionClosedModal from "./sessionClosedWarningModalComponent";
import {confirmSession} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const telemetryPort = process.env.REACT_APP_MESSAGE_PORT;

class BroadcastMessageComponent extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            messageResult: 0,
            messageCharacterLimit: 57,
            messageHasTimeout: false,
            messageTimeoutValue: 0,
            teamOnlyMessage: false,
            driverMessage: "",
            isSessionClosed: false,
            messageSet: [],
            messageTooLong: false,
        };

        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClearDriverScreen = this.handleClearDriverScreen.bind(this);
        this.handleSendMessage = this.handleSendMessage.bind(this);
        this.handleOnChangeMessage = this.handleOnChangeMessage.bind(this);
        this.handleTeamOnlyMessage = this.handleTeamOnlyMessage.bind(this);
        this.handleMessageTimeout = this.handleMessageTimeout.bind(this);
        this.handleTimeoutChange = this.handleTimeoutChange.bind(this);
        this.handleStandardMessage = this.handleStandardMessage.bind(this);
    }

    componentDidMount() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getEventMessageSet',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                eventID: helper.props.eventID,
            },
            success: function (data) {
                let final = [];
                for (let i = 0; i < data.length; i++) {
                    let regex = data[i].message.match(/<.*>/g);
                    if (regex === null || regex === undefined) {
                        final.push(data[i]);
                    }
                }
                helper.setState({
                    messageSet: final,
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    // HANDLERS
    handleShowModal() {
        this.setState({show: true});
    }

    handleClose() {
        this.setState({
            show: false,
            messageResult: 0,
            driverMessage: "",
            messageHasTimeout: false,
            teamOnlyMessage: false,
            messageTooLong: false,
        });
        Alert.closeAll();
    }

    handleClearDriverScreen() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=RT-ORG-SESSION-CARS-BROADCAST-MSG-CLOSE&eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[DASHBOARD] Successfully sent device message display closure request.');
                helper.setState({
                    driverMessage: "",
                    messageResult: 1,
                });
                helper.handleClose();
            }, error: function (err) {
                if (err) {
                    console.error('[DASHBOARD] Error sending device message display closure request.');
                    helper.setState({
                        messageResult: 2,
                    });
                    setTimeout(() => {
                        helper.handleClose();
                        helper.setState({
                            messageResult: 0,
                        });
                    }, 3000);
                }
            }
        });
    }

    handleSendMessage() {
        confirmSession(this.props.cookies.get("authToken"), this.props.eventID, this.props.sessionID, (isClosed) => {
            if (isClosed) {
                this.setState({
                    isSessionClosed: true,
                });
            } else {
                const helper = this;
                let message = this.state.driverMessage;

                if (this.state.teamOnlyMessage) {
                    $.ajax({
                        type: 'POST',
                        url: telemetryIP + ':' + telemetryPort + '/session-garage-team-broadcast-message?eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            messageDetails: {
                                userId: helper.props.userID,
                                message: Accents.remove(message),
                                messageTimeout: helper.state.messageTimeoutValue,
                            }
                        }),
                        success: function () {
                            console.log('[DASHBOARD] Successfully sent message team dashboard.');
                            helper.setState({
                                messageResult: 1,
                            });
                        }, error: function (err) {
                            if (err) {
                                console.error('[DASHBOARD] Error sending message to team dashboard.', err);
                                helper.setState({
                                    messageResult: 2,
                                });
                                setTimeout(() => {
                                    helper.handleClose();
                                    helper.setState({
                                        messageResult: 0,
                                    });
                                }, 3000);
                            }
                        }
                    });
                } else {
                    $.ajax({
                        type: 'POST',
                        url: telemetryIP + ':' + telemetryPort + '/command-worker-device?command=RT-ORG-SESSION-CARS-BROADCAST-MSG&sessionId=' + helper.props.sessionID + '&eventId=' + helper.props.eventID + '&userId=' + helper.props.userID,
                        headers: {
                            'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
                        },
                        dataType: 'json',
                        data: {
                            message: Accents.remove(message),
                        },
                        success: function () {
                            console.log('[DASHBOARD] Successfully sent device message display request.');
                            helper.setState({
                                messageResult: 1,
                                messageTimeoutValue: 0,
                            });
                        }, error: function (err) {
                            if (err) {
                                console.error('[DASHBOARD] Error sending device message display request.', err);
                                helper.setState({
                                    messageResult: 2,
                                });
                                setTimeout(() => {
                                    helper.handleClose();
                                    helper.setState({
                                        messageResult: 0,
                                        messageTimeoutValue: 0,
                                    });
                                }, 3000);
                            }
                        }
                    });
                }
            }
        });
    }

    handleOnChangeMessage(evt) {
        this.setState({
            driverMessage: evt.target.value
        }, () => {
            if (this.state.driverMessage.length > this.state.messageCharacterLimit) {
                if (!this.state.messageTooLong) {
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + this.props.t("messageTooLong") + '!</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: "none",
                        offset: 150,
                    });
                }
                this.setState({
                    messageTooLong: true,
                });
            } else {
                this.setState({
                    messageTooLong: false,
                });
                Alert.closeAll();
            }
        });
    }

    handleTeamOnlyMessage(evt) {
        this.setState({
            teamOnlyMessage: !this.state.teamOnlyMessage,
        });
    }

    handleMessageTimeout(evt) {
        this.setState({
            messageHasTimeout: !this.state.messageHasTimeout,
        });
    }

    handleTimeoutChange(evt) {
        this.setState({
            messageTimeoutValue: parseInt(evt.target.value),
        });
    }

    handleStandardMessage(evt) {
        this.setState({
            driverMessage: evt.target.value,
        }, () => {
            $("#driverMessage").val(this.state.driverMessage);
        });
    }

    render() {

        let message = "";
        if (this.state.messageResult === 1) {
            message = (<div className="alert alert-success" role="alert"><span className={"App_text"} style={{fontSize: 25}}><b>{this.props.t("confirmed")}!</b></span></div>);
        } else if (this.state.messageResult === 2) {
            message = (<div className="alert alert-danger" role="alert"><span className={"App_text"} style={{fontSize: 25}}><b>{this.props.t("actionError")}!</b></span></div>);
        } else {
            message = (<div/>);
        }

        return (
            <>
                <button
                    className={"btn btn-lg btn-primary btn-block button"}
                    onClick={this.handleShowModal}
                    style={{marginTop: 0}}
                >
                    <i className={"fas fa-envelope iconStyle"}/> {this.props.t("broadcastMsg")}
                </button>
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "medium-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <span className={"App_black_text"} style={{fontSize: 25}}> {this.props.t("sendToAllVehicles")}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <div className={"fluid-container"}>
                            <SessionClosedModal isSessionClosed={this.state.isSessionClosed}/>
                            <input type={"text"}
                                   id={"driverMessage"}
                                   className={"form-control App_black_text"}
                                   placeholder={"Write your message here (Limited to " + this.state.messageCharacterLimit + " characters!)"}
                                   onChange={this.handleOnChangeMessage}
                            />
                            {message}
                            <div className={"row"} style={{marginTop: 10}}>
                                <div className={"col-xs-4"}>
                                    <label className={"control control-checkbox text-center"} style={{marginTop: 10, display: "inline-flex"}}>
                                        <input
                                            type={"checkbox"}
                                            onClick={(event) => this.handleTeamOnlyMessage(event)}
                                        />
                                        <div className={"control_indicator"}/>
                                        <span className={"App_small_title"} style={{marginLeft: 10}}>{this.props.t("sendTeamOnly")}</span>
                                    </label>
                                </div>
                                <div className={"col-xs-5"}>
                                    <label className={"control control-checkbox text-center"} style={{marginTop: 10, display: "inline-flex"}}>
                                        <input
                                            type={"checkbox"}
                                            onClick={(event) => this.handleMessageTimeout(event)}
                                        />
                                        <div className={"control_indicator"}/>
                                        <span className={"App_small_title"} style={{marginLeft: 10}}>{this.props.t("applyTimeout")}</span>
                                    </label>
                                </div>
                                <div className={"col-xs-3"}>
                                    <button
                                        className={"btn btn-primary button"}
                                        data-toggle={"collapse"}
                                        data-target={"#stdMsg"}
                                        aria-controls={"stdMsg"}
                                    >
                                        <span><i className="fas fa-envelope-open-text"/></span>
                                        <span>{this.props.t("standard")}</span>
                                    </button>
                                </div>
                                {this.state.messageHasTimeout ? (
                                    <div className={"col-xs-6 w3-animate-fading"}>
                                        <br/>
                                        <label className={"App_small_title"}>{this.props.t("broadcastWillEnd")}</label>
                                        <input
                                            className={"form-control App_black_text"}
                                            type={"number"}
                                            placeholder={this.props.t("valueInSeconds")}
                                            onChange={this.handleTimeoutChange}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            <div className={"row"}>
                                <div className={"col-xs-12"}>
                                    <br/>
                                    <div id={"stdMsg"} className={"collapse"}>
                                        <div className={"col-xs-12 card card-body"}>
                                            {this.state.messageSet.map((message, i) => {
                                                return (
                                                    <button
                                                        key={"standard_msg_" + i}
                                                        className={"btn btn-primary button"}
                                                        style={{fontSize: 18, fontWeight: "bold", margin: "5px 5px 0 0"}}
                                                        value={message.message}
                                                        onClick={this.handleStandardMessage}
                                                    >{message.short_title}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleSendMessage}
                            disabled={this.state.driverMessage.length > this.state.messageCharacterLimit || this.state.driverMessage.length < 2}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("broadcastMessage")}
                        </button>
                        <button
                            onClick={this.handleClearDriverScreen}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("clearBroadcast")}
                        </button>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(BroadcastMessageComponent));
